"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Options = _interopRequireDefault(require("./Options"));
var _Feedback = _interopRequireDefault(require("./Feedback"));
var _styles = require("./styles");
var _mobxReact = require("mobx-react");
var _MultipleOptionsViewer = _interopRequireDefault(require("./MultipleOptions/MultipleOptionsViewer"));
var _BinaryOptions = _interopRequireDefault(require("./BinaryOptions"));
var _dec, _class;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var StepCheckToolbar = (_dec = (0, _mobxReact.inject)('store'), _dec(_class = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_Component) {
  function StepCheckToolbar() {
    _classCallCheck(this, StepCheckToolbar);
    return _callSuper(this, StepCheckToolbar, arguments);
  }
  _inherits(StepCheckToolbar, _Component);
  return _createClass(StepCheckToolbar, [{
    key: "render",
    value: function render() {
      var _store$checklist$chec, _store$checklist$chec2;
      var _this$props = this.props,
        stepId = _this$props.stepId,
        isDesktop = _this$props.isDesktop,
        stepIndex = _this$props.stepIndex,
        isMobile = _this$props.isMobile,
        checklistTemplate = _this$props.checklistTemplate,
        store = _this$props.store,
        disabledOptionsIds = _this$props.disabledOptionsIds;
      var developmentFeatureFlags = store.platform.developmentFeatureFlags;
      var onClickOption = function onClickOption(optionId) {
        var params = {
          optionId: optionId
        };
        var updateChecklist = store.checklist.updateChecklist;

        // Support for old checklists
        if (checklistTemplate.type === 'BINARY') {
          var yesOption = checklistTemplate.options.find(function (option) {
            return option.value === 1;
          });
          if (optionId === yesOption.id) {
            params.checked = true;
            params.unchecked = false;
          } else {
            params.checked = false;
            params.unchecked = true;
          }
        }
        updateChecklist(stepId, params);
      };
      return /*#__PURE__*/_react["default"].createElement(_styles.StepCheckWrapper, null, developmentFeatureFlags.checklistScoring ? checklistTemplate.type === 'BINARY' ? /*#__PURE__*/_react["default"].createElement(_BinaryOptions["default"], {
        options: checklistTemplate.options,
        onClickOption: onClickOption,
        selected: (_store$checklist$chec = store.checklist.checklist[stepId]) === null || _store$checklist$chec === void 0 ? void 0 : _store$checklist$chec.optionId,
        testIdPrefix: "binary-options-".concat(stepIndex)
      }) : /*#__PURE__*/_react["default"].createElement(_MultipleOptionsViewer["default"], {
        options: checklistTemplate.options,
        onClickOption: onClickOption,
        selected: (_store$checklist$chec2 = store.checklist.checklist[stepId]) === null || _store$checklist$chec2 === void 0 ? void 0 : _store$checklist$chec2.optionId,
        testIdPrefix: "score-options-".concat(stepIndex),
        disabledOptionsIds: disabledOptionsIds
      }) : /*#__PURE__*/_react["default"].createElement(_Options["default"], {
        stepId: stepId,
        stepIndex: stepIndex,
        isDesktop: isDesktop,
        isMobile: isMobile
      }), /*#__PURE__*/_react["default"].createElement(_Feedback["default"], {
        stepId: stepId,
        stepIndex: stepIndex,
        isDesktop: isDesktop,
        isMobile: isMobile
      }));
    }
  }]);
}(_react.Component)) || _class) || _class);
var _default = exports["default"] = StepCheckToolbar;
//# sourceMappingURL=index.js.map